import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import moment from 'utils/cops-moment';
import mapUnavailability from '../../../utils/map-unavailability';

const StyledUnavailability = styled.div`
  height: 100%;
  background-image: linear-gradient(
    90deg,
    ${(p) => {
    if (p.unavailabilityDimensions.length !== 0) {
      let cssBg = `${p.isDraggingOver ? '#DADFE3' : '#ECF2F6'} 0%,`;
      p.unavailabilityDimensions?.map(
        dimensions =>
        (cssBg +=
          `${p.isDraggingOver ? '#DADFE3' : '#ECF2F6'} ${dimensions.start}%,` +
          `${p.isDraggingOver ? '#CFD4D8' : '#DFE4E8'} ${dimensions.start}%,` +
          `${p.isDraggingOver ? '#CFD4D8' : '#DFE4E8'} ${dimensions.end}%,` +
          `${p.isDraggingOver ? '#DADFE3' : '#ECF2F6'} ${dimensions.end}%,`),
      );
      return css`
          ${cssBg.slice(0, -1)}
        `;
    }
    // eslint-disable-next-line max-len
    return css`${p.isDraggingOver ? '#DADFE3' : '#ECF2F6'} 0%, ${p.isDraggingOver ? '#DADFE3' : '#ECF2F6'} 100%`;
  }}
  );
`;

const Unavailability = ({ unavailability, viewDimensions, isDraggingOver, day }) => {
  const { startHour, endHour, widthDimension } = viewDimensions;
  const selectedDate = moment(day);

  const dayStart = selectedDate
    .clone()
    .set({ hour: startHour, minute: 0, second: 0 })
    .format('YYYY-MM-DDTHH:mm:ss');
  const dayEnd = selectedDate
    .clone()
    .set({ hour: endHour, minute: 0, second: 0 })
    .format('YYYY-MM-DDTHH:mm:ss');
  const dayStartHour = moment(dayStart);
  const dayEndHour = moment(dayEnd);
  // map unavailability-array with the calculations we need for the css background
  // maps start, end and duration to values what we need later on
  const unavailabilityDimensions = unavailability
    ?.map(unav => mapUnavailability(unav))
    ?.filter(unav => unav.startMoment.isSame(selectedDate, 'day'))
    ?.sort((unavA, unavB) => unavA.startMoment.unix() - unavB.startMoment.unix())
    ?.map((unav) => {
      const { startMoment, endMoment, durationInMinutes } = unav;
      if (
        (startMoment.isBefore(dayStartHour) || startMoment.isSame(dayStartHour)) &&
        (endMoment.isAfter(dayEndHour) || endMoment.isSame(dayEndHour))
      ) {
        // if unavailability starts before the starting hour of the day and ends after the end hour
        return {
          start: 0,
          end: 100,
        };
      } else if (startMoment.isAfter(dayStartHour) && endMoment.isBefore(dayEndHour)) {
        // if unavailability starts after the starting hour of the day and ends before the end hour
        const startDimension = startMoment.diff(dayStartHour, 'minutes') * widthDimension;
        const durationMinute = durationInMinutes * widthDimension;
        return {
          start: startDimension,
          end: startDimension + durationMinute,
        };
      } else if (
        startMoment.isAfter(dayStartHour) &&
        (endMoment.isAfter(dayEndHour) || endMoment.isSame(dayEndHour))
      ) {
        // if unavailability starts after the starting hour of the day and ends after the end hour
        const startDimension = startMoment.diff(dayStartHour, 'minutes') * widthDimension;
        return {
          start: startDimension,
          end: 100,
        };
      }
      // if unavailability starts before the starting hour of the day and ends after it
      const endDimension = endMoment.diff(dayStartHour, 'minutes') * widthDimension;
      return {
        start: 0,
        end: endDimension,
      };
    });

  return (
    <StyledUnavailability
      unavailabilityDimensions={unavailabilityDimensions}
      isDraggingOver={isDraggingOver}
    />
  );
};

Unavailability.propTypes = {
  unavailability: PropTypes.array,
  viewDimensions: PropTypes.object,
  day: PropTypes.object,
  isDraggingOver: PropTypes.bool,
};

export default Unavailability;
